import { FormattedMessage } from 'react-intl';
import NoRowsOverlayDataGrid from '../DataGrid/NoRowsOverlay';
import messages from './messages';

const NoRowsOverlay = () => (
  <NoRowsOverlayDataGrid
    dataTestId="access-log-no-records"
    headerText={<FormattedMessage {...messages.columnsNoRowsOverlayHeaderText} />}
    text={
      <FormattedMessage
        {...messages.columnsNoRowsOverlayText}
        values={{
          br: <br />,
        }}
      />
    }
  />
);

export default NoRowsOverlay;
